import type { Client } from "../types/api.types";
import type { ApiRawRecord } from "../types/common";

/**
 * Платформенный user id для связки CRM ↔ WhiteSwan / ATON.
 * Не путать `client.id` (PK в CRM) с пользователем платформы.
 */
export function crmClientPlatformUserId(
    client: Client | ApiRawRecord | null | undefined
): number | undefined {
    if (client == null) return undefined;

    const record = client as ApiRawRecord;
    const mc = (record.mainContact ?? record.main_contact) as ApiRawRecord | undefined;
    const fromContact = Number(mc?.user_id);
    if (Number.isFinite(fromContact) && fromContact > 0) {
        return fromContact;
    }
    // Платформенный user только в mainContact. `client.user_id` в index часто manager_id / служебное поле.
    return undefined;
}
